import { render, staticRenderFns } from "./BillingDashboard.vue?vue&type=template&id=05999df9&"
import script from "./BillingDashboard.vue?vue&type=script&lang=js&"
export * from "./BillingDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports